import { Theme } from "@material-ui/core"
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints"
import { isWidthDown } from "@material-ui/core/withWidth"
import { complement, is, reject } from "ramda"

export const StandardMargin = 30
export const SmallMargin = 20
export const DesktopColumnMargin = 4
export const MobileBreakpoint = "sm"
export const TabletBreakpoint = "md"

export const isMobileResolution = (width: Breakpoint) => isWidthDown(MobileBreakpoint, width)
export const isTabletResolution = (width: Breakpoint) => isWidthDown(TabletBreakpoint, width)

export const isMobile = (theme: Theme) => theme.breakpoints.down(MobileBreakpoint)

export const isDesktop = (theme: Theme) => theme.breakpoints.up(MobileBreakpoint)

export const combineClasses = (classes: string[]): string => reject(complement(is(String)), classes).join(" ")

export const LoyaltyPink = "#FF809A"
